<template>
  <div :class="{'form-floating': label}" v-if="valueModel">
    <select
      class="form-select"
      :class="{'is-invalid': errorMessage}"
      :id="'floatingSelect-' + $.uid"
      v-model="valueModel.value"
      role="button"
      :required="props.required"
      :disabled="disabled"
      @change="() => emit('change', valueModel?.value)"
      >
      <option v-if="props.emptyOptionLabel" :value="props.emptyOptionValue">{{ props.emptyOptionLabel }}</option>
      <option v-for="option in props.options"
        :key="props.valueRetriever ? props.valueRetriever(option) : option.key??option.value"
        :value="option.key??option.value??option"
        :disabled="props.disabledRetriever ? props.disabledRetriever(option) : (option.disabled == true)"
      >
        {{ props.labelRetriever ? props.labelRetriever(option) : option.label }}
      </option>
    </select>
    <label v-if="label" :for="'floatingSelect-' + $.uid">{{ props.label }} {{ props.required ? '*' : '' }}</label>
    <div class="invalid-feedback">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useField } from 'vee-validate';

const model = defineModel<string|number>({required: false});

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  label: string;
  placeholder: string;
  required: boolean;
  emptyOptionLabel?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emptyOptionValue?: string | number | any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: Array<{ key?: string|number; value: string|number|unknown; label: string, selected?: boolean, disabled?: boolean } | any>;
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueRetriever?: (option: any) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  labelRetriever?: (option: any) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disabledRetriever?: (option: any) => boolean;
}>(), {
  placeholder: '',
  emptyOptionValue: '',
  required: false,
  disabled: false,
});

const emit = defineEmits(['change'])

const { value, errorMessage } = props.valueKey !== undefined ? useField<string|number|unknown>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})
</script>
